import { Text, View } from '@react-pdf/renderer';
import { styles } from '../style/pdfStyles';
import { formatDate } from '../utils/normalize';

interface PdfFooterProps {
  idBackend?: string;
}

export const PdfFooter = ({ idBackend }: PdfFooterProps) => {
  const generationDate = formatDate(new Date());

  return (
    <View style={styles.footer} fixed>
      <View style={styles.footerRow}>
        <Text>Generato il {generationDate || '—'}</Text>
        <Text>{idBackend ? `id_backend: ${idBackend}` : 'id_backend: —'}</Text>
        <Text
          render={({ pageNumber, totalPages }) => `${pageNumber}/${totalPages}`}
        />
      </View>
    </View>
  );
};
